import {
  faBed,
  faBell,
  faClipboardList,
  faFileCertificate,
  faFileChartColumn,
  faFileCircleCheck,
  faFileInvoiceDollar,
  faFileMedical,
  faHouse,
  faKey,
  faListCheck,
  faPrescription,
  faRectangleHistory,
  faRotate,
  faScrewdriverWrench,
  faSitemap,
  faSquareList,
  faUserGear,
  faUserGroup,
  faUsersMedical,
} from '@fortawesome/pro-light-svg-icons'
import { faGear, IconDefinition } from '@fortawesome/pro-solid-svg-icons'
import { WebConfig } from '@/lib/config'

export type PortalLink = {
  title: string
  href: string
  path: string
  icon: IconDefinition
}

export const PortalLinksByRoles: {
  patient: PortalLink[]
  doctor: PortalLink[]
  superadmin: PortalLink[]
  support: PortalLink[]
} = {
  patient: [
    {
      title: 'Dashboard',
      href: '/portal',
      path: '/portal',
      icon: faSquareList,
    },
    ...(WebConfig.labResultsEnabled
      ? [
          {
            title: 'Results',
            href: '/portal/results',
            path: '/portal/results',
            icon: faFileMedical,
          },
        ]
      : []),
    {
      title: 'Profile',
      href: '/portal/profile',
      path: '/portal/profile',
      icon: faUserGear,
    },
  ],
  doctor: [
    {
      title: 'Dashboard',
      href: '/portal',
      path: '/portal',
      icon: faSquareList,
    },
    {
      title: 'Patients',
      href: '/portal/patients',
      path: '/portal/patients',
      icon: faUsersMedical,
    },
    {
      title: 'Report',
      href: '/portal/report',
      path: '/portal/report',
      icon: faFileChartColumn,
    },
    ...(WebConfig.labResultsEnabled
      ? [
          {
            title: 'Notifications',
            href: '/portal/notifications',
            path: '/portal/notifications',
            icon: faBell,
          },
        ]
      : []),
    {
      title: 'Profile',
      href: '/portal/profile',
      path: '/portal/profile',
      icon: faUserGear,
    },
  ],
  superadmin: [
    {
      title: 'Dashboard',
      href: '/portal',
      path: '/portal',
      icon: faHouse,
    },
    {
      title: 'Treatment Requests',
      href: '/portal/treatment-requests',
      path: '/portal/treatment-requests',
      icon: faFileCircleCheck,
    },
    {
      title: 'Tasks',
      href: '/portal/admin-tasks',
      path: '/portal/admin-tasks',
      icon: faClipboardList,
    },
    {
      title: 'Rejection processing',
      href: '/portal/rejection-processings',
      path: '/portal/rejection-processings',
      icon: faListCheck,
    },
    {
      title: 'Treatment Stuffs',
      href: '/portal/treatment-stuffs',
      path: '/portal/treatment-stuffs',
      icon: faGear,
    },
    {
      title: 'Patients',
      href: '/portal/patients',
      path: '/portal/patients',
      icon: faBed,
    },
    {
      title: 'Staffs',
      href: '/portal/staffs',
      path: '/portal/staffs',
      icon: faUserGroup,
    },
    {
      title: 'Medicines',
      href: '/portal/medicines',
      path: '/portal/medicines',
      icon: faPrescription,
    },
    {
      title: 'Payroll',
      href: '/portal/payroll',
      path: '/portal/payroll',
      icon: faFileInvoiceDollar,
    },
    {
      title: 'Logs',
      href: '/portal/logs',
      path: '/portal/logs',
      icon: faRectangleHistory,
    },
    {
      title: 'Organisation',
      href: '/portal/organisation',
      path: '/portal/organisation',
      icon: faSitemap,
    },
    {
      title: 'LabSync',
      href: '/portal/lab-sync',
      path: '/portal/lab-sync',
      icon: faRotate,
    },
    ...(WebConfig.labResultsEnabled
      ? [
          {
            title: 'Notifications',
            href: '/portal/notifications',
            path: '/portal/notifications',
            icon: faBell,
          },
        ]
      : []),
    {
      title: 'Agent keys',
      href: '/portal/agent-keys',
      path: '/portal/agent-keys',
      icon: faKey,
    },
    {
      title: 'Tools',
      href: '/portal/tools',
      path: '/portal/tools',
      icon: faScrewdriverWrench,
    },
    {
      title: 'Profile',
      href: '/portal/profile',
      path: '/portal/profile',
      icon: faUserGear,
    },
  ],
  support: [
    {
      title: 'Dashboard',
      href: '/portal',
      path: '/portal',
      icon: faFileCertificate,
    },
    {
      title: 'Patients',
      href: '/portal/patients',
      path: '/portal/patients',
      icon: faBed,
    },
    {
      title: 'Doctors',
      href: '/portal/staffs',
      path: '/portal/staffs',
      icon: faUserGroup,
    },
    {
      title: 'Treatment Requests',
      href: '/portal/treatment-requests',
      path: '/portal/treatment-requests',
      icon: faFileCircleCheck,
    },
    {
      title: 'Treatment Stuffs',
      href: '/portal/treatment-stuffs',
      path: '/portal/treatment-stuffs',
      icon: faGear,
    },
  ],
}
